const Overlay = (el) => {
  const triggerOpen = el.dataset.componentTriggerOpen;
  const triggerClose = el.dataset.componentTriggerClose;
  const closeTarget = el.dataset.componentCloseTarget;
  const delay = parseFloat(el.dataset.componentDelay) || 0;

  if (delay) {
    setTimeout(() => {
      open();
    }, delay * 1000);
  }

  if (closeTarget) {
    const target = el.querySelector(`.${closeTarget}`);
    if (target) {
      target.addEventListener("click", () => {
        close();
      });
    }
  }

  el.addEventListener("click", (e) => {
    if (e.target === el && el.dataset.componentForceOpen !== "true") {
      close();
    }
  });

  const open = () => {
    // el.style.display = "flex";
    if (gsap) {
      gsap.to(el, {
        opacity: 1,
        duration: 0.3,
        onStart: () => {
          el.style.display = "flex";
        },
      });
    }
  };

  const close = () => {
    if (gsap) {
      gsap.to(el, {
        opacity: 0,
        duration: 0.3,
        onComplete: () => {
          el.style.display = "none";

          const formWrapper = el.querySelector(".w-form");
          const form = formWrapper?.querySelector("form");

          form?.reset();

          formWrapper
            ?.querySelector(".w-form-done")
            ?.style.setProperty("display", "none");
          formWrapper
            ?.querySelector(".w-form-fail")
            ?.style.setProperty("display", "none");
          formWrapper
            ?.querySelector("form")
            ?.style.setProperty("display", "block");
        },
      });
    }
  };
  if (triggerOpen) {
    window[triggerOpen] = open;
  }
  if (triggerClose) {
    window[triggerClose] = close;
  }
};
export default Overlay;
